import { render, staticRenderFns } from "./SelectPartsColor.vue?vue&type=template&id=d11657ea&scoped=true&"
import script from "./SelectPartsColor.vue?vue&type=script&lang=js&"
export * from "./SelectPartsColor.vue?vue&type=script&lang=js&"
import style0 from "./SelectPartsColor.vue?vue&type=style&index=0&id=d11657ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11657ea",
  null
  
)

export default component.exports